<template>
  <svg
    v-if="icon === 'mark-check'"
    :width="width ? width : 30"
    :height="height ? height : 30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0C6.71571 0 0 6.71571 0 15C0 23.2843 6.71571 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71571 23.2843 0 15 0ZM15 2.90323C21.6854 2.90323 27.0968 8.31357 27.0968 15C27.0968 21.6854 21.6864 27.0968 15 27.0968C8.3146 27.0968 2.90323 21.6864 2.90323 15C2.90323 8.3146 8.31357 2.90323 15 2.90323ZM23.4801 10.7823L22.117 9.40821C21.8347 9.12363 21.3752 9.12175 21.0906 9.40409L12.5411 17.8849L8.92464 14.2391C8.64236 13.9545 8.1828 13.9527 7.89823 14.2349L6.52409 15.598C6.23952 15.8803 6.23764 16.3398 6.51998 16.6245L12.0108 22.1597C12.293 22.4443 12.7526 22.4462 13.0372 22.1638L23.476 11.8088C23.7605 11.5264 23.7624 11.0669 23.4801 10.7823Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'mark-warning'"
    :width="width ? width : 30"
    :height="height ? height : 30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0C6.71571 0 0 6.71571 0 15C0 23.2843 6.71571 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71571 23.2843 0 15 0ZM15 2.90323C21.6854 2.90323 27.0968 8.31357 27.0968 15C27.0968 21.6854 21.6864 27.0968 15 27.0968C8.3146 27.0968 2.90323 21.6864 2.90323 15C2.90323 8.3146 8.31357 2.90323 15 2.90323Z"
      :fill="color"
    />
    <path
      d="M16.3864 17.9674H13.7777L13.4081 7H16.7559L16.3864 17.9674ZM15.082 19.6848C15.611 19.6848 16.0349 19.8406 16.3538 20.1522C16.6799 20.4638 16.8429 20.8623 16.8429 21.3478C16.8429 21.8261 16.6799 22.221 16.3538 22.5326C16.0349 22.8442 15.611 23 15.082 23C14.5603 23 14.1364 22.8442 13.8103 22.5326C13.4915 22.221 13.332 21.8261 13.332 21.3478C13.332 20.8696 13.4915 20.4746 13.8103 20.163C14.1364 19.8442 14.5603 19.6848 15.082 19.6848Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsMark',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    bold: { type: Boolean, default: true },
  },
}
</script>

<style scoped></style>
